import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

const classifiesAsBatterOut = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.FieldOut.key:
        case PlateAppearanceResult.FoulOut.key:
        case PlateAppearanceResult.FoulTipOut.key:
        case PlateAppearanceResult.InfieldFly.key:
        case PlateAppearanceResult.SacrificeBunt.key:
        case PlateAppearanceResult.SacrificeFly.key:
        case PlateAppearanceResult.SacrificePlay.key:
        case PlateAppearanceResult.CalledStrikeout.key:
        case PlateAppearanceResult.SwingingStrikeout.key:
        case PlateAppearanceResult.BatterInterference.key:
        case PlateAppearanceResult.InfieldFly.key:
        case PlateAppearanceResult.BatterOut.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsBatterOut;